export const START_SHARE_DOC: string = 'start-share-doc'